import { useEffect, useRef } from "react";
import InfoPersoStep7Bloc from "../blocs/info-perso/InfoPersoStep7Bloc";
import { isMobile, scroll2Top } from "../utils/utils";
import GeneralDataProtectionBloc from "../blocs/common/GeneralDataProtectionBloc";

export default function InfoPersoStep7Page() {
    
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
      
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Estimez votre cotisation de base</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <InfoPersoStep7Bloc/>
        </div>
          <GeneralDataProtectionBloc/>
      </div>
      
    )

}